import { API } from "utils/api-config";

import { defaultErrorResponse } from "api/defaults";

export const reIndexVectorizationData = async (
    environmentId: string,
    tenantId: string
): Promise<[string | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const routeUrl = `/environments/${environmentId}/tenants/${tenantId}/features/vendor-similarity/vectorization-data/reindex`;
    const response = await API.post(routeUrl);

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};

export const seedVectorizationData = async (
    environmentId: string,
    tenantId: string
): Promise<[string | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const routeUrl = `/environments/${environmentId}/tenants/${tenantId}/features/vendor-similarity/vectorization-data/seed`;
    const response = await API.post(routeUrl);

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};
